<template>
    <div class="sudoku-wrap">
        <ul>
            <li
                :ref="`item${val.order}`"
                :data-index="val.order"
                :class="val.order >= 1 ? 'rw' : ''"
                v-for="val in resultList"
                :key="val.order"
            >
                <div v-if="val.order == 5 || val.order == 9 || val.order == 11" class="imgWrap imgWrap1">
                    <div class="header">
                        <img :src="val.prize_img" alt="" />
                    </div>
                </div>
                <div v-else-if="val.order > 0" class="imgWrap">
                    <div class="header">
                        <img :src="val.prize_img" alt="" />
                    </div>
                </div>
                <!-- <div v-else class="start" @click.stop.prevent="startGo"></div> -->
            </li>
        </ul>
        <div class="btnWrap">
            <div @click.stop.prevent="startGo" v-show="!isPressed">
                <img src="@/assets/images/btn01.png" alt="" />
            </div>
            <div v-show="isPressed">
                <img src="@/assets/images/btn01_pressed.png" alt="" />
            </div>
            <div class="number33">
                <img v-show="totalTimes === 3" src="@/assets/images/number33.png" alt="" />
                <img v-show="totalTimes === 2" src="@/assets/images/number23.png" alt="" />
                <img v-show="totalTimes === 1" src="@/assets/images/number13.png" alt="" />
                <img v-show="totalTimes === 0" src="@/assets/images/number03.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['isOnRound', 'awardList', 'bingosList'],
    watch: {
        isOnRound(val, oldval) {
            if (val) {
                this.totalTimes = 3
                this.isPressed = false
            }
        },
        awardList(val, oldval) {
            // 处理 最终的列表渲染顺序 已正常的排序思维顺序
            const keyObj = {}
            const arr = []
            const downArr = Object.assign([], val)
            if (downArr.length) {
                downArr.push({ order: -1 })
                downArr.push({ order: -2 })
                downArr.push({ order: -3 })
                downArr.push({ order: -9 })

                downArr.forEach(element => {
                    keyObj[element.order] = element
                })
                // 依据数组的顺序填充
                this.orderList.forEach(ele => {
                    arr.push(keyObj[ele])
                })
            }
            this.resultList = arr
            // console.log(this.resultList, '转译后的顺序')
        }
    },
    updated() {
        let that = this
        this.$nextTick(function () {
            if (localStorage.getItem('listBingo2026') && !this.isOnRound && this.bingosList.length > 0) {
                try {
                    that.bingoList = JSON.parse(localStorage.getItem('listBingo2026')) || []
                } catch (e) {
                    that.bingoList = []
                }
                that.bingoList.forEach(item => {
                    const ref = this.$refs['item' + item]
                    if (ref && ref[0]) ref[0].classList.add('dis')
                })
                if (this.bingoList.length < 4) {
                    that.totalTimes = 3 - this.bingoList.length
                } else {
                    that.totalTimes = 6 - this.bingoList.length
                }
                if (this.totalTimes <= 0) {
                    this.isPressed = true
                }
                // 刷新恢复不在这里 emit；由 App.initGift 决定进 finish，避免竞态
            }
        })
    },
    data() {
        return {
            totalTimes: 3,
            bingoList: [],
            isPressed: false,
            resultList: [], // 奖品列表
            isTurn: true, // 是否可以抽奖
            index: 1, //当前转动到哪个位置，起点位置
            orderList: [1, 2, 3, 4, 12, -9, -1, 5, 11, -2, -3, 6, 10, 9, 8, 7], // 正常循环排列下的顺序 0 为中间的抽奖按钮/分区标识
            lotterywin: -9, // 中奖位置
            lottery: {
                count: 12, //总共有多少个位置
                timer: 0, //setTimeout的ID，用clearTimeout清除
                speed: 35, //初始转动速度
                times: 0, //转动次数
                cynum: 50, // 圈数
                win: 0 //中奖位置 0 默认不中奖
            }
        }
    },
    mounted() {
        // this.resultList = this.awardList
    },
    methods: {
        getBingo() {
            // let num = Math.floor(Math.random() * (max - min + 1)) + min    //5   9   11
            let arrAll = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            let laveList = this.difference(this.bingoList, arrAll) //剩下未抽到的
            let a5r9r11 = [5, 9, 11]
            let interList = this.intersection(a5r9r11, this.bingoList) //交集
            let num = null
            do {
                if (this.bingoList.length < 3) {
                    if (this.bingoList.length == 2 && interList.length == 0) {
                        num = a5r9r11[Math.floor(Math.random() * 3)]
                    } else if (interList.length == 1) {
                        let arr = this.difference(this.union(this.bingoList, a5r9r11), arrAll)
                        num = arr[Math.floor(Math.random() * arr.length)]
                    } else {
                        num = Math.floor(Math.random() * (12 - 1 + 1)) + 1
                    }
                } else {
                    console.log('大于3')
                    if (this.bingoList.length == 5 && interList.length == 1) {
                        let arr = this.intersection(laveList, a5r9r11)
                        num = arr[Math.floor(Math.random() * 2)]
                    } else if (interList.length == 2) {
                        let arr = this.difference(this.union(this.bingoList, a5r9r11), arrAll)
                        num = arr[Math.floor(Math.random() * arr.length)]
                    } else {
                        num = laveList[Math.floor(Math.random() * laveList.length)]
                    }
                }
            } while (this.bingoList.includes(num))
            return num
        },
        startGo() {
            console.log('打点click dice')
            if (!this.isTurn || this.isPressed || this.totalTimes <= 0) return
            this.isPressed = true
            this.isTurn = false // 等待下一次开启 注：接口失败等异常情况 需要重置
            let win = this.getBingo() // 中奖位置
            if (!win) {
                // 异常时恢复可点，避免卡死
                this.isPressed = false
                this.isTurn = true
                return
            }
            this.$emit('change', 'start', {})
            this.totalTimes--
            this.lotterywin = win
            this._rolling()
        },
        resetData() {
            // 数据重置
            this.index = 1
            this.isTurn = true
            this.lottery = {
                count: 12, // 位置数量 九宫格八个奖品位置
                timer: 0, // setTimeout 容器
                speed: 35, //初始转动速度
                times: 0, //转动次数
                cynum: 50, // 圈数
                end: 0 //中奖位置 0 默认不中奖
            }
        },
        _roll_actived() {
            // running 选中的状态
            let pre = this.index - 1
            if (this.index > this.lottery.count) this.index = 1
            const preDom = this.$refs['item' + pre]
            const downDom = this.$refs['item' + this.index]
            if (pre > 0 && preDom) {
                preDom[0].classList.remove('active')
            }
            if (downDom) {
                downDom[0].classList.add('active')
            }
        },
        _rolling() {
            this.lottery.times++
            this._roll_actived()
            // +10 将速度降下来的圈数周期
            if (this.lottery.times > this.lottery.cynum + 10 && this.lotterywin === this.index) {
                clearTimeout(this.lottery.timer)
                setTimeout(() => {
                    // 用 finally 保证次数用尽时一定弹出完成页（分享/领码）
                    try {
                        this.resetData()
                        this.$emit('change', 'fin', {})
                        this.bingoList.push(this.lotterywin)
                        localStorage.setItem('listBingo2026', JSON.stringify(this.bingoList))
                        const ref = this.$refs['item' + this.lotterywin]
                        if (ref && ref[0]) {
                            ref[0].classList.add('dis') //置灰
                        }
                    } finally {
                        // 本轮次数用尽，或刚好抽满 3/6 个，进入完成页
                        const done =
                            this.totalTimes <= 0 ||
                            this.bingoList.length === 3 ||
                            this.bingoList.length === 6
                        if (done) {
                            this.isPressed = true
                            this.totalTimes = 0
                            this.$emit('handleFinish', this.bingoList.slice())
                        } else {
                            this.isPressed = false
                        }
                    }
                }, 1000) // 此时间给予用户感受中奖反馈时间
            } else {
                if (this.lottery.times > this.lottery.cynum) this.lottery.speed += 20 // 惯性 越来越慢
                this.index++
                this.lottery.timer = setTimeout(this._rolling, this.lottery.speed)
            }
        },
        // 检查差集
        difference(a, b) {
            let aSet = new Set(a)
            let bSet = new Set(b)
            return Array.from(new Set(a.concat(b).filter(v => !aSet.has(v))))
        },
        // 检查交集
        intersection(a, b) {
            return a.filter(v => b.includes(v))
        },
        // 并集
        union(a, b) {
            return a.concat(b.filter(v => !a.includes(v)))
        }
    }
}
</script>

<style scoped lang="less">
.sudoku-wrap {
    width: 100%;
    /* height: 100%; */
    margin: 0 auto;
    /* background-image: url('../assets/images/lottery_box_bg.png'); */
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    padding: 0 9.625rem;
    ul,
    li {
        list-style: none;
        padding: 0;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
            width: 10.875rem;
            height: 11.375rem;
            margin: 0 0.2rem 0.2rem 0;
            /* background-image: url('../assets/images/bg01.png'); */
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;
            position: relative;
            img {
                width: 100%;
            }
        }
        li.rw {
            padding-top: 0.14rem;
        }
    }
}
.sudoku-wrap ul li.active .imgWrap {
    background-image: url('../assets/images/bg03.png');
}
.sudoku-wrap ul li.dis .imgWrap {
    background-image: url('../assets/images/disbg01.png');
}
.sudoku-wrap ul li .imgWrap {
    height: 100%;
    background-image: url('../assets/images/bg01.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .header {
        height: 100%;
        padding: 0.625rem;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
.sudoku-wrap ul li .imgWrap1 {
    background-image: url('../assets/images/bg02.png');
}

.btnWrap {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 7rem !important;
    div {
        width: 23.375rem;
        margin: 0 auto;
        img {
            width: 100%;
        }
    }
    .number33 {
        position: absolute;
        bottom: 3.45rem;
        img {
            width: 4.5rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/monopoly.vue